import { c as _c } from "react/compiler-runtime";
import { ContactSlugEnum, FormInputSearch } from '@systemeio/ui';
import { defaultSearchFilterValue } from 'modules/contacts/constants/contact-default-filter';
import { ContactsLoco } from 'modules/contacts/constants/contacts-loco';
import { ContactSearchFieldEnum } from 'modules/contacts/enums/contact-enum';
import { useApplyFilterWithConditions } from 'modules/contacts/hooks/use-apply-filter-with-conditions';
import { useAssistantContacts } from 'modules/contacts/hooks/use-assistant-contacts';
import { useContactFields } from 'modules/contacts/hooks/use-contact-fields';
import { useContactFilterPagination } from 'modules/contacts/hooks/use-contact-filter-pagination';
import { useFilterWithConditions } from 'modules/contacts/hooks/use-filter-with-conditions';
import { ContactFilterTextInterface, ContactFilterType } from 'modules/contacts/types/contact-filter-interface';
import { ContactInterface } from 'modules/contacts/types/contact-interface';
import { NextPage } from 'next';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { OrderEnum } from 'shared/types/pagination-interface';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
const defaultFilters: ContactFilterType = {
  [ContactSlugEnum.Email]: [{
    ...defaultSearchFilterValue
  }],
  [ContactSearchFieldEnum.affiliate]: [{
    ...defaultSearchFilterValue
  }]
};
const AssistantContacts: NextPage = () => {
  const $ = _c(81);
  const {
    setConditions,
    conditions,
    filter,
    setFilter,
    filterFields,
    filtersReady
  } = useFilterWithConditions(defaultFilters);
  let t0;
  if ($[0] !== conditions || $[1] !== setConditions) {
    t0 = {
      conditions,
      setConditions
    };
    $[0] = conditions;
    $[1] = setConditions;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = useContactFilterPagination(t0);
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const {
    fields
  } = useContactFields();
  let t1;
  if ($[3] !== conditions || $[4] !== limit || $[5] !== pagination) {
    t1 = {
      limit,
      pagination,
      conditions
    };
    $[3] = conditions;
    $[4] = limit;
    $[5] = pagination;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    contacts,
    counter,
    abortContacts
  } = useAssistantContacts(t1);
  let t2;
  if ($[7] !== setPagination) {
    t2 = () => setPagination({
      startFromId: undefined,
      order: OrderEnum.next
    });
    $[7] = setPagination;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== abortContacts || $[10] !== conditions || $[11] !== filter || $[12] !== filterFields || $[13] !== filtersReady || $[14] !== setConditions || $[15] !== setLimit || $[16] !== t2) {
    t3 = {
      abort: abortContacts,
      filterFields,
      filtersReady,
      setLimit,
      setConditions,
      conditions,
      filter,
      onFilterChange: t2,
      delay: 0
    };
    $[9] = abortContacts;
    $[10] = conditions;
    $[11] = filter;
    $[12] = filterFields;
    $[13] = filtersReady;
    $[14] = setConditions;
    $[15] = setLimit;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  useApplyFilterWithConditions(t3);
  let t4;
  if ($[18] !== t) {
    t4 = t("dashboard.contacts.date_registered");
    $[18] = t;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  let t5;
  if ($[20] !== user?.dateFormat || $[21] !== user?.timeFormat || $[22] !== user?.timezone) {
    t5 = contact => <span>{dateTimeFormat(contact.registeredAt, {
        timeFormat: user?.timeFormat,
        dateFormat: user?.dateFormat,
        timeZone: user?.timezone
      })}</span>;
    $[20] = user?.dateFormat;
    $[21] = user?.timeFormat;
    $[22] = user?.timezone;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  let t6;
  if ($[24] !== t4 || $[25] !== t5) {
    t6 = {
      key: "registeredAt",
      header: t4,
      onRender: t5,
      widthPercent: 30
    };
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] !== t) {
    t7 = t("dashboard.user.first_name");
    $[27] = t;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== t7) {
    t8 = {
      key: "fieldValues",
      header: t7,
      onRender: _temp2,
      widthPercent: 30
    };
    $[29] = t7;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== t) {
    t9 = t("global.email_address");
    $[31] = t;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== t9) {
    t10 = {
      key: "email",
      header: t9,
      widthPercent: 40,
      onRender: _temp3
    };
    $[33] = t9;
    $[34] = t10;
  } else {
    t10 = $[34];
  }
  let t11;
  if ($[35] !== t10 || $[36] !== t6 || $[37] !== t8) {
    t11 = [t6, t8, t10];
    $[35] = t10;
    $[36] = t6;
    $[37] = t8;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  const columns = t11;
  let t12;
  if ($[39] !== t) {
    t12 = t("dashboard.contacts.title_plural");
    $[39] = t;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== limit || $[42] !== setLimit) {
    t13 = {
      limit,
      setLimit
    };
    $[41] = limit;
    $[42] = setLimit;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  let t14;
  if ($[44] !== pagination || $[45] !== setPagination) {
    t14 = {
      pagination,
      setPagination
    };
    $[44] = pagination;
    $[45] = setPagination;
    $[46] = t14;
  } else {
    t14 = $[46];
  }
  let t15;
  if ($[47] !== filter || $[48] !== setFilter) {
    t15 = {
      filter,
      setFilter,
      defaultFilters
    };
    $[47] = filter;
    $[48] = setFilter;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  let t16;
  if ($[50] !== fields || $[51] !== t) {
    t16 = {
      field: ContactSlugEnum.Email,
      onRender: (value, onChange) => {
        const email = value[0] as ContactFilterTextInterface;
        return <FormInputSearch key="email-filter" value={email.searchValue} type="email" onClear={() => onChange([{
          compareOperation: email.compareOperation,
          searchValue: ""
        }])} onChange={e => onChange([{
          compareOperation: email.compareOperation,
          searchValue: e.target.value
        }])} placeholder={t("global.email")} isPreFetching={!fields} />;
      }
    };
    $[50] = fields;
    $[51] = t;
    $[52] = t16;
  } else {
    t16 = $[52];
  }
  let t17;
  if ($[53] !== fields || $[54] !== t) {
    t17 = {
      field: ContactSearchFieldEnum.affiliate,
      onRender: (value_0, onChange_0) => {
        const affiliate = value_0[0] as ContactFilterTextInterface;
        return <FormInputSearch key="affiliate-filter" value={affiliate.searchValue} onClear={() => onChange_0([{
          compareOperation: affiliate.compareOperation,
          searchValue: ""
        }])} onChange={e_0 => onChange_0([{
          compareOperation: affiliate.compareOperation,
          searchValue: e_0.target.value
        }])} placeholder={t("dashboard.contacts.filter.affiliate_id")} isPreFetching={!fields} />;
      }
    };
    $[53] = fields;
    $[54] = t;
    $[55] = t17;
  } else {
    t17 = $[55];
  }
  let t18;
  if ($[56] !== t16 || $[57] !== t17) {
    t18 = [t16, t17];
    $[56] = t16;
    $[57] = t17;
    $[58] = t18;
  } else {
    t18 = $[58];
  }
  let t19;
  if ($[59] !== t13 || $[60] !== t14 || $[61] !== t15 || $[62] !== t18) {
    t19 = {
      limiter: t13,
      paginator: t14,
      filterer: t15,
      filterable: t18
    };
    $[59] = t13;
    $[60] = t14;
    $[61] = t15;
    $[62] = t18;
    $[63] = t19;
  } else {
    t19 = $[63];
  }
  let t20;
  if ($[64] !== limit || $[65] !== setLimit) {
    t20 = {
      limit,
      setLimit
    };
    $[64] = limit;
    $[65] = setLimit;
    $[66] = t20;
  } else {
    t20 = $[66];
  }
  let t21;
  if ($[67] !== pagination || $[68] !== setPagination) {
    t21 = {
      pagination,
      setPagination
    };
    $[67] = pagination;
    $[68] = setPagination;
    $[69] = t21;
  } else {
    t21 = $[69];
  }
  let t22;
  if ($[70] !== columns || $[71] !== contacts || $[72] !== t20 || $[73] !== t21) {
    t22 = <Table data={contacts} columns={columns} limiter={t20} paginator={t21} />;
    $[70] = columns;
    $[71] = contacts;
    $[72] = t20;
    $[73] = t21;
    $[74] = t22;
  } else {
    t22 = $[74];
  }
  let t23;
  if ($[75] !== contacts || $[76] !== counter || $[77] !== t12 || $[78] !== t19 || $[79] !== t22) {
    t23 = <><ListingLayout data={contacts} title={t12} type="compact" counter={counter} filterData={t19}>{t22}</ListingLayout></>;
    $[75] = contacts;
    $[76] = counter;
    $[77] = t12;
    $[78] = t19;
    $[79] = t22;
    $[80] = t23;
  } else {
    t23 = $[80];
  }
  return t23;
};
export const getServerSideProps = getBaseServerSideProps(ContactsLoco, 'header.top_menu.contacts');
export default AssistantContacts;
function _temp(el) {
  return el.contactField.slug === ContactSlugEnum.FirstName;
}
function _temp2(contact_0) {
  return <div className="truncate">{contact_0.fieldValues.find(_temp)?.value || ""}</div>;
}
function _temp3(contact_1) {
  return <div className="truncate"><LinkWithoutPrefetch className="primary-link w-full" href={`/contacts/${contact_1.id}`}>{contact_1.email}</LinkWithoutPrefetch></div>;
}